import axios from "axios";
import config from "../../../config";

const baseUrl = config.baseUrl;
const Endpoint = "/api/datosInforme";
const EndpointInformeGeneral = "/api/getInformacionGeneralPatti";

// Crear una instancia de Axios para configurar base URL y otras opciones
const api = axios.create({
  baseURL: config.baseUrl,
});

const getDatosVisitas = async () => {
  try {
    const response = await api.get(`${baseUrl}${Endpoint}`);
    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    console.error("Error fetching datos de visitas:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetchingdatos de visitas",
    };
  }
};

export const getInformeGeneralPatti = async (email) => {
  try {
    const response = await axios.post(
      `${baseUrl}${EndpointInformeGeneral}`,
      { email }, // Cuerpo de la solicitud con el email
      {
        headers: {
          "Content-Type": "application/json", // Encabezado JSON para enviar datos correctamente
        },
      }
    );
    return {
      data: response.data,
    };
  } catch (error) {
    console.error("Error fetching datos:", error);
    return {
      status: error.response ? error.response.status : 500,
      message: "Error fetch datos",
    };
  }
};

export default getDatosVisitas;
